var itemsModule = function (itemsCollection, shipmentCollection, _estimateShippingPostcode, ViewCheckoutPixel) {
    if (!itemsCollection) return;

    var ItemView = Backbone.View.extend({
        events: {
            'click @increase': 'increase',
            'click @decrease': 'decrease',
            'click @delete': 'delete'
        },
        initialize: function () {
            _.bindAll(this);
            this.model.on('change', this.render);
            this.model.on('remove', this.destroy);
            this.spinner = new Spinner(smallSpinnerConfig);
            this.render();
        },
        render: function () {
            this.$el.html($.tmpl('bt-checkout-item', this.model.toJSON()));
            this.$increase = this.$('@increase');
            this.$decrease = this.$('@decrease');
        },
        increase: function (e) {
            if (this.disableButtons) return;
            this.spinStart(e.currentTarget);
            window.app && app.event && app.event.increaseItemQty();
            this.model.increase().always(this.spinStop);
        },
        decrease: function (e) {
            if (this.disableButtons) return;
            this.spinStart(e.currentTarget);
            window.app && app.event && app.event.decreaseItemQty();
            this.model.decrease().always(this.spinStop);
        },
        delete: function (e) {
            if (this.disableButtons) return;
            this.disableButtons = true;
            this.$el.addClass('opacity-block');
            window.app && app.event && app.event.deleteOrderItem();
            var _this = this;
           this.model.delete().always(function() {
               _this.disableButtons = false;
           });
        },
        spinStart: function (button) {
            this.disableButtons = true;
            this.spinner.spin(button.parentNode);
            this.$pressedButton = $(button).hide();
        },
        spinStop: function () {
            this.spinner.stop();
            this.$pressedButton.show();
            this.disableButtons = false;
        },
        destroy: function () {
            this.undelegateEvents();
            this.$el.removeData().unbind();
            this.remove();
            Backbone.View.prototype.remove.call(this);
        }
    });

    var ItemsListView = Backbone.View.extend({
        el: '@itemListContainer',
        initialize: function (opts) {
            _.bindAll(this);
            this.itemClassName = opts.itemClassName || 'list-row';
            this.collection.on('add', this.renderItem);
            this.render();
        },
        render: function () {
            this.$el.toggleClass('hidden-block', (this.collection._display !== true));
            this.collection.each(this.renderItem);
        },
        renderItem: function (model) {
            var item = new ItemView({ model: model, className: this.itemClassName });
            this.$el.append(item.$el);
        }
    });

    var ShipmentView = Backbone.View.extend({
        events: {
            'click @estimateFormBtn': '_focusEstimateForm',
            'click @summaryDeliveryPostfixPostcode': '_focusEstimateForm'
        },
        initialize: function () {
            _.bindAll(this, '_render', '_destroy', '_postcodeChanged');
            this.model.on('change', this._render);
            this.model.on('remove', this._destroy);
            this._render();
            _estimateShippingPostcode.on(this._postcodeChanged);
        },

        _postcodeChanged: function () {
            var settings = CheckoutSettings.getBasketSettings();
            var estimateShipmentPostcode = this.model.get('EstimateShipmentPostcode');
            var postcode = estimateShipmentPostcode || '';// _estimateShippingPostcode.get();
            if (settings.ShippingByPostcodeEnabled === true && postcode) {
                this.$('@summaryDeliveryPostfix').removeClass('hidden-block');
                this.$('@summaryDeliveryPostfixPostcode').text(postcode);
            }
        },

        _render: function () {
            var data = this.model.toJSON();
            data.SelectStatus = app.models.delivery.options.getOurpaySelectStatus();
            data.WarningMessage = this._getWarningMessage(data);
            this.$el.html($.tmpl('bt-checkout-shipment', data));
            this.$itemsList = this.$('@shipmentItemsList');
            this.itemsView = new ItemsListView({ el: this.$itemsList, collection: this.model.get('Items'), itemClassName: 'list-row' });
            this._postcodeChanged();
        },

        _getWarningMessage: function(data) {
            var message = GetPageTemplate('_ImpossibleToDeliverAtLocation');
            if (data.MinimumDeliveryPriceThreshold) {
                var amount = toMoney(data.MinimumDeliveryPriceThreshold, GlobalSettings.CurrencySign);
                message = GetPageTemplate('_ShippingMinimumOrderValue').replace('[0]', amount);
            }
            return message;
        },

        _destroy: function () {
            this.undelegateEvents();
            this.$el.removeData().unbind();
            this.remove();
            Backbone.View.prototype.remove.call(this);
        },
        _focusEstimateForm: function () {
            $('@estimatePostcode').focus();
        }
    });

    var ShipmentsListView = Backbone.View.extend({
        el: '@shipmentsListContainer',
        initialize: function () {
            _.bindAll(this);
            this.collection.on('add', this.renderShipment);
            this.render();
        },
        render: function () {
            this.$el.toggleClass('hidden-block', (this.collection._display !== true));
            this.collection.each(this.renderShipment);
        },
        renderShipment: function (model) {
            var item = new ShipmentView({ model: model });
            this.$el.append(item.$el);
        }
    });

    new ItemsListView({ collection: itemsCollection });
    new ShipmentsListView({ collection: shipmentCollection });

    ViewCheckoutPixel && ViewCheckoutPixel.view(itemsCollection);
};